import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FileService } from 'src/app/services/api/file.service';

export interface ServiceObservacionesDialogData {
  id: string;
  observaciones?: string | null;
}

export interface ServiceObservacionesDialogResult {
  success: boolean;
  observaciones?: string | null;
}

@Component({
  selector: 'app-dialog-service-observaciones',
  templateUrl: './dialog-service-observaciones.component.html',
  styleUrls: ['./dialog-service-observaciones.component.css']
})
export class DialogServiceObservacionesComponent implements OnInit {
  observacionesControl = new FormControl('', [Validators.maxLength(500)]);
  loader = false;
  latestObservaciones: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<
      DialogServiceObservacionesComponent,
      ServiceObservacionesDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: ServiceObservacionesDialogData,
    private readonly fileService: FileService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.latestObservaciones = this.data.observaciones ?? null;
    this.observacionesControl.setValue(this.latestObservaciones ?? '');

    this.fileService.getServiceObservation(this.data.id).subscribe({
      next: (result) => {
        const observaciones = result?.getServiceObservation?.observaciones;
        this.latestObservaciones = observaciones ?? null;
        this.observacionesControl.setValue(this.latestObservaciones ?? '');
      },
      error: () => {
        this.toastr.error(
          'No se pudieron cargar las observaciones del servicio.'
        );
      }
    });
  }

  saveObservaciones(): void {
    this.loader = true;
    this.observacionesControl.markAsTouched();

    if (this.observacionesControl.invalid) {
      this.loader = false;
      return;
    }

    const observaciones = this.observacionesControl.value?.trim() || '';

    this.fileService
      .updateObservacionesServices(this.data.id, observaciones)
      .subscribe({
        next: () => {
          this.loader = false;
          this.dialogRef.close({
            success: true,
            observaciones
          });
        },
        error: () => {
          this.loader = false;
          this.toastr.error(
            'No se pudo actualizar las observaciones del servicio.'
          );
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close({
      success: false,
      observaciones: this.latestObservaciones
    });
  }
}
